import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const chapters = [
  {
    num: "01",
    title: "La Nostra Storia",
    body: "Fondata nel 1985 a Modena, Cobi Meccanica costruisce attrezzature, prototipi e componenti meccanici di precisione. Quarant'anni di crescita costante, radicata nel territorio e alimentata da investimenti continui in tecnologia, impianti e persone.",
  },
  {
    num: "02",
    title: "La Nostra Visione",
    body: "Allargare la grande famiglia Cobi investendo sui giovani e sul territorio, offrendo formazione e tirocini agli istituti tecnici della provincia di Modena, e supportando le eccellenze sportive che ci contraddistinguono.",
  },
  {
    num: "03",
    title: "La Nostra Missione",
    body: "Tenere testa alla frenesia del mercato con investimenti mirati: nuovi centri di lavoro, nuove aree di collaudo e macchine tridimensionali che alzano costantemente competitività e qualità del marchio Cobi.",
  },
];

const Chapter = ({ ch }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "start 40%"] });
  const color = useTransform(scrollYProgress, [0, 1], ["#3f3f46", "#fafafa"]);

  return (
    <div ref={ref} data-testid={`chapter-${ch.num}`} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-14 border-t border-white/10">
      <div className="md:col-span-3 flex md:block items-center gap-4">
        <span className="font-display font-black text-5xl md:text-7xl text-red-600">{ch.num}</span>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 md:mt-4 block">Capitolo</span>
      </div>
      <div className="md:col-span-9">
        <h3 className="font-display font-bold text-3xl md:text-5xl tracking-tight mb-5">{ch.title}</h3>
        <motion.p style={{ color }} className="text-lg md:text-2xl leading-relaxed max-w-3xl">
          {ch.body}
        </motion.p>
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-36">
    <Reveal>
      <div className="flex items-center gap-3 mb-10">
        <span className="w-8 h-px bg-red-600" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Parliamo di noi</span>
      </div>
    </Reveal>
    <div>
      {chapters.map((ch) => (
        <Chapter key={ch.num} ch={ch} />
      ))}
    </div>
  </section>
);
